export default __webpack_public_path__ + "static/media/woman.4b13fb7a.png";